import useSWR from 'swr';

import { serviceProvidersList } from '~/data/generated/endpoints/service-providers/service-providers';
import { parseApiResponse } from '~/data/parseApiResponse';
import { serviceProviderListSchema } from '~/data/schemas/serviceProvider';

interface UseProvidersOptions {
  propertyId?: string;
}

export const useProviders = ({ propertyId }: UseProvidersOptions) => {
  const {
    data: providers,
    error,
    isLoading,
  } = useSWR(propertyId ? ['providers', propertyId] : null, async () => {
    const { data } = await serviceProvidersList({ property_id: propertyId });
    return parseApiResponse(serviceProviderListSchema, data, 'Providers');
  });

  return {
    providers,
    error,
    loading: isLoading,
  };
};
